export default __webpack_public_path__ + "static/media/scroll_down.ff6b69d3.svg";